export const coordenadaTypes = {
    SET_COORDENADA: '[Coordenada] SET_COORDENADA',
}